module.exports = __webpack_public_path__ + "static/media/ultimate_ninjas.57a0834a.png";